/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Body_change_team_icon_admin_change_team_icon__team_id__post = {
    properties: {
        file: {
            type: 'binary',
            isRequired: true,
            format: 'binary',
        },
    },
} as const;
